import { render, staticRenderFns } from "./screenReportes.vue?vue&type=template&id=2395ab12"
import script from "./screenReportes.vue?vue&type=script&lang=js"
export * from "./screenReportes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports